class XeroController extends AbstractIntegrationController
	@register()
	@inject '$window',
		'configuration'
		'configurationOptions'
		'IntegrationService'
		'IntegrationRepository'
		'VatRates'
		'TenderTypes'
		'ToastService'
		'CopyService'
		'Shops'
		'ProductCategories'
		'ProductRepository'
		'translate'

	integrationId: 'xero'

	initialize: ->
		if _.isEmpty @configurationOptions
			return

		@isActive = @configuration.is_active
		@tenant = @configuration.tenant
		@defaultValueId = 'default'

		@trackingOptions = @configurationOptions.trackingOptions[@configuration.settings.tracking_category_id]

		if Array.isArray(@configuration.mappings) then @configuration.mappings = {}
		if Array.isArray(@configuration.settings) then @configuration.settings = {}

		@category = null
		@categories = []

		@actions =
			save: @isActive
			disconnect: true

		@filterDTO = new FilterDTO({
			searchConfiguration: {name: {property: 'name', label: 'general.name'}}
			count: 0
		})

		@shops = @Shops.data
		@vatRates = @VatRates.data
		@tenderTypes = @TenderTypes.data
		@productCategories = _.filter @ProductCategories.data, (category) -> category.parent_id == null
		@paymentAccounts = @IntegrationService.getPaymentAccounts()

		@creditNoteStatuses = _.map @configurationOptions.creditNoteStatuses, (status) =>
			{
				id: status,
				name: @translate('wbo.integration.xero.credit_note.status.' + status.toLowerCase())
			}

		@creditNotePaymentStatuses = _.map @configurationOptions.creditNotePaymentStatuses,(status) =>
			{
				id: status,
				name: @translate('wbo.integration.xero.credit_note_payment.status.' + status.toLowerCase())
			}

		@initializeTabs()
		@searchProducts()

	initializeTabs: ->
		@tabs = [
			{
				title: 'wbo.integration.xero.tab.general'
				selector: '#tab-xero-general'
			},
			{
				title: 'wbo.integration.xero.tab.product'
				selector: '#tab-xero-product'
			},
			{
				title: 'wbo.integration.xero.tab.payment'
				selector: '#tab-xero-payment'
			},
			{
				title: 'wbo.integration.xero.tab.shop'
				selector: '#tab-xero-shop'
			},
			{
				title: 'wbo.integration.xero.tab.vat'
				selector: '#tab-xero-vat'
			},
			{
				title: 'wbo.integration.xero.tab.log'
				selector: '#tab-xero-log'
			},
		]

	save: ->
		super @configuration

	afterDisconnect: ->
		@isActive = false

	runIntegration: (timestampFrom, timestampTo, timeZone) ->
		@saving = true

		requestBody =
			filters:
				timestamp_from: timestampFrom
				timestamp_to: timestampTo
				time_zone: timeZone

		@IntegrationRepository
			.run @integrationId, requestBody
			.then =>
				@ToastService.add(
					@$filter('translate')(@headerText).toString(),
					@$filter('translate')('general.integration'),
					@$filter('translate')('general.operation.success'),
					'success'
				)
			.catch (response) =>
				@ToastService.showErrors response, @$filter('translate')(@headerText).toString()
			.finally =>
				@saving = false

	goToAuthorizationPage: ->
		@IntegrationRepository
			.fetch("/#{@integrationId}/authorization/url")
			.then (response) =>
				@$window.location.href = response.data.url
			.catch =>
				@ToastService.add(
					@$filter('translate')(@headerText).toString(),
					@$filter('translate')('general.integration'),
					@$filter('translate')('general.error'),
					'error'
				)

	updateChildCategoriesList: ->
		if @category == null
			return

		@categories = [@category]

		@categories.push(...@getChildCategories(@category.id))

	getChildCategories: (parentId) ->
		categories = _.filter @ProductCategories.data, (category) -> category.parent_id == parentId

		for category in categories
			categories.push(...@getChildCategories(category.id));

		return categories

	searchProducts: ->
		query = @filterDTO.getQuery()

		@ProductRepository
			.getEntitiesWithCount query, true
			.then (response) =>
				@filterDTO.count = response.count
				@products = response.data

	handleTrackingCategoryChange: ->
		# Clearing current mappings, because we do not need mixing of options from different tracking categories
		@configuration.mappings.cost_centers = {}
		@trackingOptions = @configurationOptions.trackingOptions[@configuration.settings.tracking_category_id]
